/* Reminder: also update index.js if you're adding new APIs */

/*
Note: these "DEV" and "PROD" refer to *backend* environments, not frontend.
For example, the "dev" frontend could still be configured to use the DEV backend APIs here.

Environment variables for the frontend should be configured in/via the Amplify builds.
*/

const config = {
  DEV: {
    webSocket: {
      constructorUrl: "wss://05vqdqte6a.execute-api.us-west-2.amazonaws.com/prod",
      groupPlaySessionUrl: "wss://5231mnp2sb.execute-api.us-west-2.amazonaws.com/prod/",
    },
    apiGateway: {
      REGION: "us-west-2",
      URLs: {
        userPuzzles: "https://kasnw67q96.execute-api.us-west-2.amazonaws.com/prod",
        loginTable: "https://3ko0sznvw0.execute-api.us-west-2.amazonaws.com/prod",
        ticketGenerator: "https://mjzlxwsjh4.execute-api.us-west-2.amazonaws.com/prod",
        userSupport: "https://mmwess3es1.execute-api.us-west-2.amazonaws.com/prod",
        subscriptions: "https://x5wepmcckd.execute-api.us-west-2.amazonaws.com/prod",
        suggestorEngine: "https://27dtpha4jl.execute-api.us-west-2.amazonaws.com/prod",
        snakeHighscores: "https://y6j4slg2fk.execute-api.us-west-2.amazonaws.com/prod",
        wordlists: "https://b3k8djbjb2.execute-api.us-west-2.amazonaws.com/prod",
        userPreferences: "https://hqyephjrf7.execute-api.us-west-2.amazonaws.com/prod",
        groupPlaySessions: "https://9o2yugbmua.execute-api.us-west-2.amazonaws.com/prod",
      },
    },
    cognito: {
      REGION: "us-west-2",
      USER_POOL_ID: "us-west-2_fwtaZR39P",
      APP_CLIENT_ID: "77jr46eqtmoqdthroilc8qd305",
      IDENTITY_POOL_ID: "us-west-2:a2778130-56c9-4b8d-8d3a-b70bea8826d8",
    },
  },

  PROD: {
    webSocket: {
      constructorUrl: "wss://blhk1kv8cg.execute-api.us-west-2.amazonaws.com/prod",
      groupPlaySessionUrl: "wss://xm7ml8w19l.execute-api.us-west-2.amazonaws.com/prod/",
    },
    apiGateway: {
      REGION: "us-west-2",
      URLs: {
        userPuzzles: "https://kf7oj6pqze.execute-api.us-west-2.amazonaws.com/prod",
        loginTable: "https://q30nhuo90d.execute-api.us-west-2.amazonaws.com/prod",
        ticketGenerator: "https://fthjozsv3f.execute-api.us-west-2.amazonaws.com/prod",
        userSupport: "https://b7ljomq9bf.execute-api.us-west-2.amazonaws.com/prod",
        subscriptions: "https://db33qjjw3c.execute-api.us-west-2.amazonaws.com/prod",
        suggestorEngine: "https://k3m6gghua0.execute-api.us-west-2.amazonaws.com/prod",
        snakeHighscores: "https://frketczw6h.execute-api.us-west-2.amazonaws.com/prod",
        wordlists: "https://5pjiz7ydf8.execute-api.us-west-2.amazonaws.com/prod",
        userPreferences: "https://lbyw1cpfud.execute-api.us-west-2.amazonaws.com/prod",
        groupPlaySessions: "https://pr8yj4dsv6.execute-api.us-west-2.amazonaws.com/prod",
      },
    },
    cognito: {
      REGION: "us-west-2",
      USER_POOL_ID: "us-west-2_AcM688q4h",
      APP_CLIENT_ID: "41jdisd3ethp1vv27ebb8jpk5o",
      IDENTITY_POOL_ID: "us-west-2:f32f52a2-ecba-4706-b221-30e8c5cb470b",
    },
  },
};

export default config;